var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopyWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_656_8004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6 5.27832C15.2365 5.27832 15.847 5.53118 16.2971 5.98126C16.7471 6.43135 17 7.0418 17 7.67832L17 14.6783C17 15.3148 16.7471 15.9253 16.2971 16.3754C15.847 16.8255 15.2365 17.0783 14.6 17.0783L7.4 17.0783C6.76348 17.0783 6.15303 16.8255 5.70295 16.3754C5.25286 15.9253 5 15.3148 5 14.6783L5 7.67832C5 7.0418 5.25286 6.43135 5.70294 5.98127C6.15303 5.53118 6.76348 5.27832 7.4 5.27832L14.6 5.27832ZM15.8 7.67832C15.8 7.36006 15.6736 7.05484 15.4485 6.82979C15.2235 6.60475 14.9183 6.47832 14.6 6.47832L7.4 6.47832C7.08174 6.47832 6.77652 6.60475 6.55147 6.82979C6.32643 7.05484 6.2 7.36006 6.2 7.67832L6.2 14.6783C6.2 14.9966 6.32643 15.3018 6.55147 15.5269C6.77652 15.7519 7.08174 15.8783 7.4 15.8783L14.6 15.8783C14.9183 15.8783 15.2235 15.7519 15.4485 15.5268C15.6736 15.3018 15.8 14.9966 15.8 14.6783L15.8 7.67832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3984 7.0784C19.3984 6.65712 19.2875 6.24327 19.0769 5.87843C18.8662 5.5136 18.5633 5.21064 18.1984 5L18.1984 15.2784C18.1984 16.0741 17.8824 16.8371 17.3198 17.3997C16.7572 17.9623 15.9941 18.2784 15.1984 18.2784L7.72004 18.2784C7.93068 18.6432 8.23364 18.9462 8.59847 19.1568C8.96331 19.3675 9.37716 19.4784 9.79844 19.4784L15.1984 19.4784C16.3123 19.4784 17.3806 19.0359 18.1683 18.2483C18.9559 17.4606 19.3984 16.3923 19.3984 15.2784L19.3984 7.0784Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_656_8004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyWhite);
export default __webpack_public_path__ + "static/media/copy-white.281c08a57fedc41bd52c992dd892fcbb.svg";
export { ForwardRef as ReactComponent };